import { render, staticRenderFns } from "./not-qualified.vue?vue&type=template&id=07aae25e&scoped=true&"
import script from "./not-qualified.vue?vue&type=script&lang=js&"
export * from "./not-qualified.vue?vue&type=script&lang=js&"
import style0 from "./not-qualified.vue?vue&type=style&index=0&id=07aae25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aae25e",
  null
  
)

export default component.exports